/* eslint-disable no-unused-vars */
import { useLazyQuery } from "@apollo/client";
import {
  Box,
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { AutoTextArea, BasicSwitchText, TextBox, TitleSubTitle } from "@platformx/utilities";
import { XImageRender } from "@platformx/x-image-render";
// import { useTranslation } from "react-i18next";
import { FETCH_TOPIC_LIST } from "@platformx/authoring-apis";
import { useEffect, useState } from "react";
import { useStyles } from "./NotificationSetting.styles";

const NotificationSetting = ({ titleSubTitles, state, setState }) => {
  // const { t } = useTranslation();
  const classes = useStyles();
  const {
    notificationTitle,
    notificationSubTitle,
    notificationFieldName,

    notificationImageTitle,
    notificationImageSubTitle,
    notificationImageFieldName,

    mainTitle,
    mainSubTitle,
    titlePlaceHolder,
    titleMaxCharLength,
    titleFieldName,

    descriptionTitle,
    descriptionSubTitle,
    descriptionPlaceHolder,
    descriptionFieldName,
    descriptionMaxCharLength,

    channelTitle,
    channelSubTitle,
    channelFieldName,

    notificationTopic,
    notificationSubTopic,
    notificationTopicFieldName,
  } = titleSubTitles;
  const [selectedChannelTypes, setSelectedChannelTypes] = useState<string[]>([]);
  const [selectedNotificationTopic, setSelectedNotificationTopic] = useState<string[]>([]);
  const [runFetchTagList] = useLazyQuery(FETCH_TOPIC_LIST);
  const channelTypeOptions = [
    { value: "Web", label: "Web" },
    { value: "App", label: "App" },
  ];
  const [notificationTopicOptions, setNotificationTopicOptions] = useState<
    { value: string; label: string }[]
  >([]);

  useEffect(() => {
    runFetchTagList({
      variables: { start: 0, rows: 1000 },
    })
      .then((res) => {
        const topics = res?.data?.authoring_fetchTopics || [];
        setNotificationTopicOptions(
          topics.map((topic: any) => ({
            value: topic.label || topic.id || topic,
            label: topic.label || topic.id || topic,
          })),
        );
      })
      .catch((error: any) => {
        setNotificationTopicOptions([]);
        console.error("error in topic fetching", error);
      });
  }, [runFetchTagList]);

  //useEffect to sync local state with main state
  useEffect(() => {
    if (state?.[channelFieldName]) {
      setSelectedChannelTypes(state[channelFieldName]);
    }
    if (state?.[notificationTopicFieldName]) {
      setSelectedNotificationTopic(state[notificationTopicFieldName]);
    }
  }, [state, channelFieldName, notificationTopicFieldName]);

  const handleOnBlur = (event) => {
    setState({
      ...state,
      CommonFields: {
        ...state.CommonFields,
        [event.target.name]: event.target.value,
      },
    });
  };
  const handleChange = (event, keyName) => {
    setState({
      ...state,
      CommonFields: {
        ...state.CommonFields,
        [keyName]: event?.target?.checked,
      },
    });
  };

  const handleNotificationImageChange = (data) => {
    const { fieldName } = data;
    setState((prevState) => {
      return {
        ...prevState,
        CommonFields: {
          ...prevState.CommonFields,
          [fieldName]: data?.original_image?.Thumbnail || data.relativeUrl,
        },
      };
    });
    // contentRef.current = {
    //   ...contentRef.current,
    //   [fieldName]: imageData,
    // };
    // unsavedChanges.current = true;
  };
  const handleChannelTypeChange = (event) => {
    const { value } = event.target;
    const selectedValues = typeof value === "string" ? value.split(",") : value;

    setSelectedChannelTypes(selectedValues);
    handleDropdownChange({
      target: {
        name: channelFieldName,
        value: selectedValues,
      },
    });
  };

  const handleDropdownChange = (event) => {
    const { name, value } = event.target;
    setState((prevState) => {
      return {
        ...prevState,
        CommonFields: {
          ...prevState.CommonFields,
          [name]: value,
        },
      };
    });
  };
  const handleNotificationTopicChange = (event) => {
    const { value } = event.target;
    let selectedValues = typeof value === "string" ? value.split(",") : value;

    // Handle "Select All" functionality
    if (selectedValues.includes("SELECT_ALL")) {
      const allValues = notificationTopicOptions.map((option) => option.value);
      const currentSelected = state?.[notificationTopicFieldName] || selectedNotificationTopic;

      // If all are selected, deselect all; otherwise select all
      selectedValues = currentSelected.length === allValues.length ? [] : allValues;
    }

    setSelectedNotificationTopic(selectedValues);
    handleDropdownChange({
      target: {
        name: notificationTopicFieldName,
        value: selectedValues,
      },
    });
  };
  return (
    <Box className={classes.container}>
      <Box className={classes.fullrowItem}>
        <BasicSwitchText
          state={Boolean(state?.CommonFields?.[notificationFieldName])}
          isDisable={false}
          handleChange={handleChange}
          title={notificationTitle}
          subtitle={notificationSubTitle}
          keyName={notificationFieldName}
        />
      </Box>
      <Box className={classes.fullrowItem}>
        <TitleSubTitle
          title={mainTitle}
          subTitle={mainSubTitle}
          titleVariant='h6medium'
          subTitleVariant='p4regular'
        />
        <Box className={classes.gap}>
          <TextBox
            name={titleFieldName}
            placeHolder={titlePlaceHolder}
            handleOnBlur={handleOnBlur}
            maxCharLength={titleMaxCharLength}
            state={(state?.CommonFields?.[titleFieldName] || "").substring(0, 120)}
          />
        </Box>
      </Box>
      <Box className={classes.fullrowItem}>
        <TitleSubTitle
          title={descriptionTitle}
          subTitle={descriptionSubTitle}
          titleVariant='h6medium'
          subTitleVariant='p4regular'
        />
        <Box className={classes.gap}>
          <AutoTextArea
            name={descriptionFieldName}
            placeHolder={descriptionPlaceHolder}
            handleOnBlur={handleOnBlur}
            maxCharLength={descriptionMaxCharLength}
            state={state?.CommonFields?.[descriptionFieldName] || ""}
          />
        </Box>
      </Box>
      <Box className={classes.fullrowItem}>
        <TitleSubTitle
          title={notificationImageTitle}
          subTitle={notificationImageSubTitle}
          titleVariant='h6medium'
          subTitleVariant='p4regular'
        />
        {/* <XImageRender
          callBack={uploadSocialImage}
          editData={{
            relativeUrl: state.CommonFields.settings.socialog_image,
          }}
        /> */}
        <Box className={classes.gap}>
          <XImageRender
            callBack={(data) => {
              const callbackData = {
                ...data,
                fieldName: notificationImageFieldName,
              };
              handleNotificationImageChange(callbackData);
            }}
            editData={{
              relativeUrl:
                typeof state?.CommonFields?.[notificationImageFieldName] === "string"
                  ? state?.CommonFields[notificationImageFieldName]
                  : "",
            }}
            isCrop={false}
          />
        </Box>
      </Box>
      <Box className={classes.fullrowItem}>
        <TitleSubTitle
          title={channelTitle}
          subTitle={channelSubTitle}
          titleVariant='h6medium'
          subTitleVariant='p4regular'
        />
        <Box className={classes.gap}>
          <FormControl fullWidth>
            <Select
              labelId='channel-type-label'
              id='channel-type-multiselect'
              multiple
              value={
                Array.isArray(state?.CommonFields?.[channelFieldName])
                  ? state.CommonFields[channelFieldName]
                  : selectedChannelTypes
              }
              onChange={handleChannelTypeChange}
              input={<OutlinedInput label={channelTitle} />}
              // renderValue={(selected) => (selected as string[]).join(", ")}
              renderValue={(selected) => (Array.isArray(selected) ? selected.join(", ") : "")}>
              {channelTypeOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  <Checkbox
                    checked={(
                      state?.CommonFields?.[channelFieldName] || selectedChannelTypes
                    ).includes(option.value)}
                  />
                  <ListItemText primary={option.label} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
      <Box className={classes.fullrowItem}>
        <TitleSubTitle
          title={notificationTopic}
          subTitle={notificationSubTopic}
          titleVariant='h6medium'
          subTitleVariant='p4regular'
        />
        <Box className={classes.gap}>
          <FormControl fullWidth>
            <Select
              labelId='notification-topic-label'
              id='notification-topic-multiselect'
              multiple
              value={
                Array.isArray(state?.CommonFields?.[notificationTopicFieldName])
                  ? state.CommonFields[notificationTopicFieldName]
                  : selectedNotificationTopic
              }
              onChange={handleNotificationTopicChange}
              displayEmpty
              input={<OutlinedInput label={notificationTopic} />}
              // renderValue={(selected) => (selected as string[]).join(", ")}
              renderValue={(selected) => (Array.isArray(selected) ? selected.join(", ") : "")}>
              {/* Select All Option */}
              <MenuItem value='SELECT_ALL'>
                <Checkbox
                  checked={
                    notificationTopicOptions.length > 0 &&
                    (state?.CommonFields?.[notificationTopicFieldName] || selectedNotificationTopic)
                      .length === notificationTopicOptions.length
                  }
                  indeterminate={
                    (state?.CommonFields?.[notificationTopicFieldName] || selectedNotificationTopic)
                      .length > 0 &&
                    (state?.CommonFields?.[notificationTopicFieldName] || selectedNotificationTopic)
                      .length < notificationTopicOptions.length
                  }
                />
                <ListItemText primary='Select All' />
              </MenuItem>

              {notificationTopicOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  <Checkbox
                    checked={(
                      state?.CommonFields?.[notificationTopicFieldName] || selectedNotificationTopic
                    ).includes(option.value)}
                  />
                  <ListItemText primary={option.label} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
    </Box>
  );
};

export default NotificationSetting;
